// extracted by mini-css-extract-plugin
module.exports = {"head":"styles_head__reM97","body":"styles_body__mITND","olly":"styles_olly___HGYy"};